import { render, staticRenderFns } from "./ShareMatrix.vue?vue&type=template&id=3965b28e&scoped=true"
import script from "./ShareMatrix.vue?vue&type=script&lang=js"
export * from "./ShareMatrix.vue?vue&type=script&lang=js"
import style0 from "./ShareMatrix.vue?vue&type=style&index=0&id=3965b28e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3965b28e",
  null
  
)

export default component.exports